import {
  MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES,
  MAX_POSSIBLE_STAKE_PRICE,
  MIN_POSSIBLE_STAKE_PRICE,
} from 'app/constants/userRestrictions';
import { type I18Lang, isSupportedLang } from 'app/lang';
import { DELIMITERS_BY_LANG } from 'app/lib/formatters';

const DOT_SYMBOL_LENGTH = 1;
const DENIED_CHARS = /[^0-9.,]+/g; // Находит все цифры, точки и запятые

/**
 * Make amount value safe for further calculations.
 */
export function secureAmountValue(
  value: string,
  decimals = MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES,
): string {
  value = value.replace(',', '.').replace(DENIED_CHARS, '');

  const dotIndex = value.indexOf('.');

  if (dotIndex !== -1) { // Максимальное количество знаков после запятой
    value = value.substring(0, dotIndex + DOT_SYMBOL_LENGTH + decimals);
  }

  return value;
}

export const isCorrectNumber = (
  value: string,
  options?: {
    decimals?: number;
    allowEmptyValue?: boolean;
  },
): boolean => {
  const decimals = options?.decimals ?? MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES;
  const allowEmptyValue = options?.allowEmptyValue ?? true;

  value = value.replace(',', '.');

  if (value === '' && allowEmptyValue) {
    return true;
  }

  const isNumeric = !Number.isNaN(parseFloat(value)) && isFinite(+value);

  const hasExponentValue = (value: string): boolean => /e/i.test(value);

  if (!isNumeric || hasExponentValue(value)) {
    return false;
  }

  const splitByDot = value.split('.');

  const integer = Number(splitByDot[0]);
  const fraction = splitByDot[1];

  if (fraction?.length > decimals) {
    return false; // Максимальное количество знаков после запятой
  }

  return (integer < MAX_POSSIBLE_STAKE_PRICE && integer >= MIN_POSSIBLE_STAKE_PRICE);
};

export const regionalFormating = (value: string, lang: I18Lang): string => {
  const thousandsSeparator = isSupportedLang(lang)
    ? DELIMITERS_BY_LANG[lang].thousands
    : ' ';

  return value.replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSeparator);
};
